import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=55e24074&scoped=true&lang=pug"
import script from "./slide.vue?vue&type=script&lang=js"
export * from "./slide.vue?vue&type=script&lang=js"
import style0 from "./slide.vue?vue&type=style&index=0&id=55e24074&prod&scoped=true&lang=css"
import style1 from "./slide.vue?vue&type=style&index=1&id=55e24074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e24074",
  null
  
)

export default component.exports